import AvilabilityCalendar from './AvilabilityCalendar';

export default AvilabilityCalendar;
